import { useInfiniteQuery } from '@tanstack/react-query';
import { apiGet, type ApiError } from '../lib/api';

export interface AdminUserRow {
  user_id: string;
  email: string;
  display_name: string | null;
  created_at: string;
  subscription_tier: string;
  subscription_status: string;
  has_completed_onboarding: boolean;
  is_sim: boolean;
  is_admin: boolean;
  deleted_at: string | null;
  last_active_at: string | null;
  current_streak: number;
  verdict: string | null;
}

export interface UsersPage {
  rows: AdminUserRow[];
  next_cursor: string | null;
}

export interface UserFilters {
  q: string;
  status: string | null;
  showSim: boolean;
  sort: 'created_at' | 'email';
  dir: 'asc' | 'desc';
}

export function useUsers(filters: UserFilters) {
  return useInfiniteQuery<UsersPage, ApiError>({
    queryKey: ['admin', 'users', filters],
    initialPageParam: null as string | null,
    getNextPageParam: (last) => last.next_cursor,
    queryFn: ({ pageParam }) =>
      apiGet('/admin/users', {
        q: filters.q || undefined,
        status: filters.status ?? undefined,
        // The toggle is "show simulated users" — on means both, off means real only.
        is_sim: filters.showSim ? 'all' : 'false',
        sort: filters.sort,
        dir: filters.dir,
        cursor: (pageParam as string | null) ?? undefined,
        limit: 50,
      }) as Promise<UsersPage>,
  });
}
